import { useTranslation } from '@numistic/i18n'

/** Страница ждёт данных: вместо пустого экрана — короткое «Загрузка…» (и для скринридера). */
export function PageLoading() {
  const { t } = useTranslation()
  return (
    <p role="status" aria-busy="true" className="text-sm text-muted-foreground">
      {t('common.loading')}
    </p>
  )
}
